/**
 * Event invitation — udfoldelig tilmeldingsformular med Klaviyo-tilmelding.
 *
 * Tilmeldingen sendes til Klaviyos client-side subscriptions-endpoint, som er
 * designet til at blive kaldt fra en browser med en OFFENTLIG nøgle (company id).
 * Der må aldrig ligge en privat API-nøgle i sektionens indstillinger.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  if (!window.customElements || customElements.get('event-invitation-form')) return;

  customElements.define('event-invitation-form', class extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('[data-toggle]');
      this.form      = this.querySelector('[data-form]');
      this.errorEl   = this.querySelector('[data-error]');
      this.successEl = this.querySelector('[data-success]');
      this.submitBtn = this.querySelector('[data-submit]');
      this.hp        = this.querySelector('[data-hp]');
      if (!this.toggleBtn || !this.form) return;

      this.submitLabel = this.submitBtn ? this.submitBtn.textContent : '';
      this.busy = false;

      this.toggleBtn.addEventListener('click', this.onToggle.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onToggle() {
      var open = this.classList.toggle('is-open');
      this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = this.querySelector('[data-first]');
        // Vent til udfoldningen er i gang, ellers scroller browseren til et element med højde 0
        window.setTimeout(function () {
          if (first) first.focus({ preventScroll: false });
        }, 360);
      }
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    setBusy(state) {
      this.busy = state;
      if (!this.submitBtn) return;
      this.submitBtn.disabled = state;
      this.submitBtn.textContent = state
        ? (this.dataset.busyLabel || this.submitLabel)
        : this.submitLabel;
    }

    onSubmit(e) {
      e.preventDefault();
      if (this.busy) return;

      // Honeypot: udfyldt betyder bot. Kvittér som om alt gik godt.
      if (this.hp && this.hp.value) { this.renderSuccess(); return; }

      var first = (this.querySelector('[data-first]') || {}).value || '';
      var last  = (this.querySelector('[data-last]')  || {}).value || '';
      var email = (this.querySelector('[data-email]') || {}).value || '';
      first = first.trim(); last = last.trim(); email = email.trim();

      this.clearError();

      if (!first || !last || !email) {
        this.showError(this.dataset.errorRequired || 'Udfyld venligst alle felter.');
        return;
      }
      if (!EMAIL_RE.test(email)) {
        this.showError(this.dataset.errorEmail || 'Indtast en gyldig e-mailadresse.');
        var el = this.querySelector('[data-email]');
        if (el) { el.setAttribute('aria-invalid', 'true'); el.focus(); }
        return;
      }

      var companyId = this.dataset.companyId;
      var listId    = this.dataset.listId;
      if (!companyId || !listId) {
        this.showError(this.dataset.errorGeneric || 'Noget gik galt.');
        return;
      }

      this.setBusy(true);
      var self = this;

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'revision': this.dataset.revision || '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, first_name: first, last_name: last }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      })
        .then(function (res) {
          // Klaviyo svarer 202 Accepted uden indhold når tilmeldingen er modtaget
          if (res.ok || res.status === 202) { self.renderSuccess(); return; }
          return res.text().then(function (t) {
            console.error('[invitation] Klaviyo svarede ' + res.status + ': ' + t);
            self.setBusy(false);
            self.showError(self.dataset.errorGeneric || 'Noget gik galt.');
          });
        })
        .catch(function (err) {
          console.error('[invitation] netværksfejl', err);
          self.setBusy(false);
          self.showError(self.dataset.errorGeneric || 'Noget gik galt.');
        });
    }

    renderSuccess() {
      this.form.hidden = true;
      if (this.successEl) this.successEl.hidden = false;
      if (this.toggleBtn) this.toggleBtn.hidden = true;
      this.classList.add('is-open', 'is-done');
    }
  });
})();
